<template>
  <div class="preview_page">
    <div _title="面包屑">
      <div class="preview_bread">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ name: 'indexPage' }"
            >素材库首页</el-breadcrumb-item
          >
          <el-breadcrumb-item>{{
            type == 1 ? "BP演示版" : type == 2 ? "BP文档版" : ""
          }}</el-breadcrumb-item>
          <el-breadcrumb-item>当前作品</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div _title="主体" class="clearfix">
      <div _title="左侧" class="preview_left">
        <div class="preview_left_block" id="recommend">
          <div _title="标题和预览图" class="preview_info">
            <div _title="第一行" class="preview_info_line preview_info_first">
              <h1 class="preview_info_title">
                <!-- {{  imageList[0]  }} -->
                <!-- {{ types }} -->
                <!-- 头部 -->
                <!-- {{ form.tag }} -->

                <span>{{ types }}</span> {{ isFrom.name }}
                <p class="h1_p">
                  <em> <i class="iconfont iconai-eye"></i>{{ isFrom.pv }} </em>
                  <em> <i class="iconfont iconaixin"></i>{{ isFrom.laud }} </em>
                </p>
              </h1>
              <div
                class="preview_info_fav_not"
                v-show="isFrom.collect == false"
                @click="collection()"
              >
                <div class="preview_info_fav_line">
                  <i class="el-icon-star-off"></i>
                  <span class="preview_info_fav_text">收藏</span>
                </div>
              </div>
              <div
                class="preview_info_fav"
                v-show="isFrom.collect == true"
                @click="collection()"
              >
                <div class="preview_info_not">
                  <i class="el-icon-star-on"></i>
                  <span class="preview_info_fav_text">已收藏</span>
                </div>
              </div>
              <!-- <ul>
                                <li>张三呀</li>
                            </ul> -->
            </div>

            <ul>
              <!-- {{ newimageList }} -->
              <li v-for="item in newimageList" :key="item.index">
                <div class="m-center-cntr">
                  <div class="t-c">
                    <img
                      class="preview_img_list_item_cover"
                      :src="item"
                      alt=""
                    />
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="preview_left_block" style="padding: 10px">
          <div class="preview_left_like">
            <h6 class="p_left_title">相关推荐</h6>
            <!-- PPT -->
            <div v-show="type == 1" class="articles-list ppt-list">
              <article
                class="post"
                v-for="(item, index) in recomList.slice(0, 12)"
                :key="index"
              >
                <div class="inner" @click="jump(1, item)" style="width: 195px">
                  <div class="media-pic">
                    <img
                      :src="item.cover"
                      width="600"
                      height="400"
                      alt=""
                      class="wp-post-image"
                    />
                  </div>
                  <div class="media-body">
                    <a class="title" :title="item.name">
                      {{ item.name }}
                    </a>
                  </div>
                  <div class="clearfix">
                    <p class="post-meta fr">
                      <em>
                        <i class="iconfont iconai-eye"></i>{{ item.pv }}
                      </em>
                      <em>
                        <i class="iconfont iconaixin"></i>{{ item.laud }}
                      </em>
                    </p>
                  </div>
                </div>
              </article>
            </div>
            <!-- WORD -->
            <div v-show="type == 2" class="articles-list word-grid-list">
              <article
                class="post posts word-grid-item"
                v-for="(item, index) in recomList.slice(0, 6)"
                :key="index"
                @click="jump(2, item)"
                style="cursor: pointer;"
              >
                <div class="word-grid-inner">
                  <div class="word-grid-img-wrap">
                    <img :src="item.cover" alt="" />
                  </div>
                  <div class="word-grid-content">
                    <a class="word-grid-title">{{ item.name }}</a>
                    <div class="flex-ca">
                      <div class="flex_div">
                        <em>
                          <i class="iconfont iconai-eye"></i>{{ item.pv }}
                        </em>
                        <em>
                          <i class="iconfont iconaixin"></i>{{ item.laud }}
                        </em>
                      </div>
                    </div>
                    <div class="mix_back" v-if="item.tag">
                      <span
                        class="mix_back_span"
                        v-for="(citem, cindex) in (item.tag || '').split(',')"
                        :key="cindex"
                      >
                        {{ citem }}
                      </span>
                    </div>
                  </div>
                </div>
              </article>
            </div>
          </div>
        </div>
      </div>
      <div _title="右侧" class="preview_right">
        <div class="preview_right_block">
          <div>
            <!-- 下载信息 -->
            <div>
              <h3 class="wb-title">下载信息</h3>

              <!-- 价格信息 -->
              <div v-if="!canDownload">
                <span class="preview_price_title">单 价：</span>
                <span _title="现价">
                  <span class="preview__price">
                    ￥
                    <span _title="现价数值" class="preview_price_final_value">
                      {{ isFrom.price }}
                    </span>
                  </span>
                </span>
              </div>

              <!-- 操作按钮 -->
              <div>
                <div
                  class="Downloadnow"
                  @click="buy()"
                  v-show="!canDownload"
                >
                  购买
                </div>
                <div
                  class="Downloadnow"
                  v-show="canDownload"
                  @click="download()"
                >
                  直接下载
                </div>

                <p class="botto_p">
                  <span class="copyinfo_title">温馨提示：</span>
                  <span>建议使用Microsoft Office、WPS打开文件，以避免可能出现的排版错乱问题。</span>
                </p>
                <p class="botto_p">
                  <span class="copyinfo_title">授权范围：</span>
                  <span>可做商用</span>
                </p>
                <p class="botto_p">
                  <span class="copyinfo_title">授权对象：</span>
                  <span class="copy_one">个人</span>
                  <span class="copy_two" v-show="hasEcardPermission">高校</span>
                </p>
                <p class="botto_p">
                  <span class="copyinfo_title">版权所有：</span>
                  <span>素材库</span>
                </p>
              </div>
            </div>
            <!-- 时间页数详情 -->
            <ul class="preview_detail clearfix">
              <li class="preview_detail_item">编号: {{ isFrom.code }}</li>
              <li class="preview_detail_item">作者: {{ isFrom.author }}</li>
              <li class="preview_detail_item">页数: {{ isFrom.page }}页</li>
              <li class="preview_detail_item">格式: {{ isFrom.format }}</li>
              <li class="preview_detail_item">
                动画类型:
                {{
                  isFrom.animation == 0
                    ? "无"
                    : isFrom.animation == 1
                    ? "路演"
                    : isFrom.animation == 2
                    ? "网评"
                    : ""
                }}
              </li>
              <li class="preview_detail_item">
                <!-- <div class="mix_back"> -->
                <!-- <span class="" v-for="(citem,cindex) in form.tag.split(',')" :key="cindex" :title="form.tag">
                                            <span class="mix_back_span"  >
                                        
                                                {{citem}}
                                            </span>
                                        </span> -->
                <!-- </div> -->
              </li>
            </ul>
          </div>
        </div>
        <!-- 相关片段 -->
        <div
          class="preview_like_block"
          id="torecommed"
          :class="
            Fixed ? 'preview_like_fixed' : Fixeds ? 'preview_like_bottom' : ''
          "
        >
          <div class="preview_like">
            <h6 class="preview_like_title">相关片段</h6>
            <div class="preview_designer_tab_content clearfix">
              <!-- PPT -->
              <div v-show="type == 1">
                <article
                  class="post"
                  v-for="(item, index) in partList.slice(0, 4)"
                  :key="index"
                >
                  <div
                    class="inner"
                    @click="jump(1, item)"
                    style="width: 195px"
                  >
                    <div class="media-pic">
                      <!-- <i class="tag-vip"></i> -->
                      <img
                        :src="(item.image || '').split(',')[0]"
                        width="600"
                        height="400"
                        alt=""
                        class="wp-post-image"
                      />
                      <!-- <router-link :to="{name:'PPThome'}" class="post-cate">
                                                <em class="tag-213">
                                                    演示版
                                                </em>
                                            </router-link> -->
                    </div>
                    <div class="media-body">
                      <a href="" class="title" :title="item.name">
                        {{ item.name }}
                      </a>
                    </div>
                    <div class="clearfix">
                      <p class="post-date fl">
                        <span class="anticon">
                          <i class="el-icon-time"></i>
                        </span>
                        {{ item.time }}
                      </p>
                      <p class="post-meta fr">
                        <em>
                          <i class="iconfont iconai-eye"></i>{{ item.pv }}
                        </em>
                        <em>
                          <i class="iconfont iconaixin"></i>{{ item.laud }}
                        </em>
                      </p>
                    </div>
                  </div>
                </article>
              </div>
              <!-- WORD -->
              <div v-show="type == 2" class="articles-list">
                <article
                  class="post posts"
                  v-for="(item, index) in partList.slice(0, 4)"
                  :key="index"
                >
                  <div class="wode_iner" @click="jump(2, item)">
                    <img :src="item.image" alt="" />
                    <div class="flex-ccj">
                      <a class="">{{ item.name }}</a>
                      <div class="flex-ca">
                        <span class="anticon">
                          <i class="el-icon-time"></i>
                        </span>
                        <span>{{ item.time }}</span>
                        <div class="flex_div">
                          <em>
                            <i class="iconfont iconai-eye"></i>{{ item.pv }}
                          </em>
                          <em>
                            <i class="iconfont iconaixin"></i>{{ item.laud }}
                          </em>
                        </div>
                      </div>
                      <div class="mix_back">
                        <span
                          class=""
                          v-for="(citem, cindex) in (item.tag || '').split(',')"
                          :key="cindex"
                        >
                          <span class="mix_back_span">
                            {{ citem }}
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </article>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 支付弹窗 -->
    <div class="pay_Popup">
      <el-dialog
        title="购买文档"
        :visible.sync="dialogVisible"
        width="780px"
        :before-close="handleClose"
        :show-close="false"
      >
        <i
          class="el-icon-close closei"
          @click="closei()"
          v-show="pay_num != 2"
        ></i>
        <div v-show="pay_num == 1 && showtime == false">
          <div class="muban_detail">
            <p class="name"><i class="line"></i>{{ buys.title || isFrom.name || '购买文档' }}</p>
            <p class="ordernum">交易订单：{{ buys.number }}</p>
            <p class="final_price_wrapper">
              实际支付：
              <span class="final_price">
                <span class="symbol">￥</span> {{ isFrom.price }}
              </span>
            </p>
          </div>
          <div class="qrcode_wrapper clearfix">
            <!-- 微信 -->
            <div class="pay-wx fl">
              <div class="wx-ewm">
                <img :src="wxPayCode" alt="" />
              </div>
              <div class="wx-icon">
                <img src="./../../assets/wx-icon.png" alt="" />微信扫码支付
              </div>
            </div>
            <!-- 支付宝 -->
            <div class="pay-zfb fr" @click="paybuy()">
              <div class="zfb-ewm">
                <img src="./../../assets/pay-zfb.png" alt="" />
              </div>
              <div class="pay-zfb-btn">
                <img src="./../../assets/zfb-icon.png" alt="" />去支付宝支付
              </div>
            </div>
          </div>
        </div>
        <div class="Paysuccess" v-show="pay_num == 2">
          <div class="Pay_div">
            <i class="el-icon-check"></i>
          </div>
          <p class="Pay_p1">支付成功</p>
          <p class="Pay_p2">{{ time }}S后自动跳转至...</p>
          <p class="Pay_p3" @click="jumps()">立即跳转</p>
        </div>
        <div v-show="showtime == true">
          <div class="mask_bg"></div>
          <div class="loading_wrapper">
            <i></i>
          </div>
        </div>
      </el-dialog>
    </div>
    <BetterLogin :title="title" @childFn="parentFn"></BetterLogin>
  </div>
</template>
<script>
import permissionManager from '../../utils/ecardPermissionManager';

export default {
  data() {
    return {
      newimageList: [], //图片
      isFrom: {
        tag: ""
      }, //名字item
      ruleForm: {},
      rules: {},
      form: {
        tag: ""
      },
      wxPayCode: "",
      Fixed: 0,
      Fixeds: 0,
      dialogSmallP: false,
      dialogVisible: false,
      title: "",
      imageList: [],
      types: "",
      partList: [],
      buys: {},
      showtime: true,
      time: "",
      pay_num: 1,
      recomList: [],
      type: 0,
      // 新增：本地订单号（使用文件code作为key，避免跨文件订单号混乱）
      localOrderNumber: "",
      localOrderFileCode: "", // 记录订单号对应的文件code
      timing: null, // 支付状态轮询定时器
      // 电子卡权限状态
      hasEcardPermission: false,
      permissionLoading: true
    };
  },
  computed: {
    // 计算是否可以下载：已购买 或 有电子卡权限
    canDownload() {
      return this.isFrom.buy === true || this.hasEcardPermission;
    }
  },
  methods: {
    // 获取本地缓存的订单号（与当前文件code关联）
    getLocalOrderNumber(fileCode) {
      const orderKey = `order_number_${fileCode}`;
      const orderNumber = localStorage.getItem(orderKey);
      return orderNumber || "";
    },
    
    // 保存订单号到本地缓存（与文件code关联）
    saveLocalOrderNumber(fileCode, orderNumber) {
      const orderKey = `order_number_${fileCode}`;
      if (orderNumber) {
        localStorage.setItem(orderKey, orderNumber);
      } else {
        localStorage.removeItem(orderKey);
      }
    },
    
    // 清除本地订单号缓存
    clearLocalOrderNumber(fileCode) {
      const orderKey = `order_number_${fileCode}`;
      localStorage.removeItem(orderKey);
    },
    
    // 检查电子卡权限
    async checkEcardPermission() {
      if (!this.$store.state.token) {
        this.hasEcardPermission = false;
        this.permissionLoading = false;
        return;
      }

      try {
        // 根据当前模块类型检查对应的电子卡权限
        let moduleMark = 1; // 默认互联网+模块
        
        // 可以根据路由参数或其他方式确定当前模块
        if (this.$route.query.module) {
          moduleMark = parseInt(this.$route.query.module);
        } else {
          // 根据type参数判断模块类型
          // type == 1: BP演示版 -> 互联网+模块(1)
          // type == 2: BP文档版 -> 互联网+模块(1)
          // 可以根据实际业务需求调整
          moduleMark = 1; // 互联网+模块
        }
        
        this.hasEcardPermission = await permissionManager.hasModulePermission(
          this.$store.state.token, 
          moduleMark
        );
      } catch (error) {
        console.error('检查电子卡权限失败:', error);
        this.hasEcardPermission = false;
      } finally {
        this.permissionLoading = false;
      }
    },

    // 判断是否为小程序跳转
    loginKto() {
      var SmallFss = window.__wxjs_environment === "miniprogram";
      if (SmallFss == true) {
        if (
          this.$route.query.openid != "undefined" &&
          this.$route.query.openid != undefined &&
          this.$route.query.openid != null &&
          this.$route.query.openid != "null" &&
          this.$route.query.openid != ""
        ) {
          this.$store.dispatch("openid", this.$route.query.openid);
          this.axios
            .loginkto({
              openid: this.$store.state.openid
            })
            .then(res => {
              if (res.data.code == 200) {
                this.$store.dispatch("token", res.data.data.token);
                this.$store.dispatch("account", res.data.data.account);
                this.$store.dispatch("avatar", res.data.data.avatar);
                this.$store.dispatch("userName", res.data.data.name);
                this.$store.dispatch("vip", res.data.data.vip);
                this.$store.dispatch("vipName", res.data.data.vipName);
                this.$store.dispatch("vipDate", res.data.data.vipDate);
                this.getapp();
                // 重新检查电子卡权限
                this.checkEcardPermission();
              }
            })
            .catch(err => {});
        } else {
          this.getapp();
        }
      } else {
        return false;
      }
    },
    getapp() {
      this.code = this.$route.query.code;
      this.type = this.$route.query.type;
      
      // 检查是否有mark参数（用于职规赛等模块）
      const mark = this.$route.query.mark;
      const previewParams = {
        code: this.code,
        token: this.$store.state.token
      };
      
      // 如果路由中有mark参数，添加到请求参数中
      if (mark) {
        previewParams.mark = mark;
      }
      
      this.axios
        .preview({
          params: previewParams
        })
        .then(res => {
          if (res.data.code == 200) {
            this.isFrom = res.data.data.item; //名字
            this.types = res.data.data.type; //完整版
            this.partList = res.data.data.part;

            if ((this.isFrom.image || "").split(",").length != 0) {
              this.newimageList = (this.isFrom.image || "").split(",");
            }
          } else {
            // 显示后端返回的错误信息
            this.$message.error(res.data.message || res.data.msg || '获取文件详情失败');
            console.error('Preview API返回错误:', res.data);
          }
        })
        .catch(err => {
          console.error('Preview API调用失败:', err);
          // 显示详细的错误信息
          if (err.response) {
            const status = err.response.status;
            const data = err.response.data;
            if (status === 500) {
              this.$message.error(data?.message || data?.msg || `服务器错误(500): 文件code=${this.code}，请检查后端日志或联系管理员`);
            } else {
              this.$message.error(data?.message || data?.msg || `获取文件详情失败(${status})`);
            }
          } else {
            this.$message.error('网络错误，请检查网络连接');
          }
        });
      //详情页推荐
      this.axios
        .recomm({
          params: {
            code: this.code
          }
        })
        .then(res => {
          if (res.data.code == 200) {
            this.recomList = res.data.data;
          } else {
            this.recomList = [];
          }
        })
        .catch(err => {
          // 推荐接口调用失败，静默处理
        });
    },
    // 购买
    buy() {
      if (
        this.$store.state.token == "" ||
        this.$store.state.token == undefined
      ) {
        this.title = true;
        return;
      }
      
      const fileCode = this.isFrom.code;
      if (!fileCode) {
        this.$message.error('文件信息获取失败，请刷新页面重试');
        return;
      }
      
      // 优先用本地未支付订单号（必须属于当前文件）
      let orderNumber = this.getLocalOrderNumber(fileCode);
      if (orderNumber) {
        // 查询订单状态，并验证订单是否属于当前文件
        this.axios
          .orderquery({
            params: {
              number: orderNumber,
              token: this.$store.state.token
            }
          })
          .then(res => {
            if (res.data.code == 200 && res.data.data) {
              const orderData = res.data.data;
              const state = orderData.state;
              
              // 验证订单是否属于当前文件
              if (orderData.code && orderData.code !== fileCode) {
                // 订单不属于当前文件，清除并创建新订单
                this.clearLocalOrderNumber(fileCode);
                this.createOrder();
                return;
              }
              
              if (state == 0) {
                // 未支付，继续使用该订单号
                this.buys = orderData;
                // 如果orderquery接口返回的数据中没有title，使用isFrom的name作为备选
                if (!this.buys.title && this.isFrom.name) {
                  this.buys.title = this.isFrom.name;
                }
                this.localOrderNumber = orderNumber;
                this.localOrderFileCode = fileCode;
                this.dialogVisible = true;
                this.showtime = true; // 显示加载状态
                this.wxPayCode = ""; // 清空之前的二维码
                this.payWithOrderNumber(orderNumber);
                return;
              } else if (state == 1 || state == 7) {
                // 支付完成或金额不符，清除本地订单号
                this.clearLocalOrderNumber(fileCode);
                this.localOrderNumber = "";
                this.localOrderFileCode = "";
              }
            }
            // 没有可用订单号，走正常下单流程
            this.createOrder();
          })
          .catch(() => {
            // 查询失败，走正常下单流程
            this.createOrder();
          });
      } else {
        this.createOrder();
      }
    },
    createOrder() {
      const fileCode = this.isFrom.code;
      if (!fileCode) {
        this.$message.error('文件信息获取失败，请刷新页面重试');
        return;
      }
      
      this.dialogVisible = true;
      this.showtime = true; // 显示加载状态
      this.wxPayCode = ""; // 清空之前的二维码
      this.axios
        .ordertrade({
          code: fileCode,
          token: this.$store.state.token
        })
        .then(res => {
          if (res.data && res.data.code == 200 && res.data.data) {
            this.buys = res.data.data;
            // 确保title存在，如果API没有返回title，使用isFrom.name
            if (!this.buys.title && this.isFrom.name) {
              this.buys.title = this.isFrom.name;
            }
            // 保存订单号到本地（与文件code关联）
            this.saveLocalOrderNumber(fileCode, this.buys.number);
            this.localOrderNumber = this.buys.number;
            this.localOrderFileCode = fileCode;
            this.payWithOrderNumber(this.buys.number);
          } else {
            this.$message.info(res.data.message);
            this.dialogVisible = false;
          }
        })
        .catch(err => {
          this.$message.error('创建订单失败，请重试');
          this.dialogVisible = false;
        });
    },
    payWithOrderNumber(orderNumber) {
      // 清除之前的定时器（如果存在）
      if (this.timing) {
        clearInterval(this.timing);
        this.timing = null;
      }
      
      // 确保显示加载状态
      this.showtime = true;
      this.wxPayCode = "";
      
      this.axios
        .orderpay({
          token: this.$store.state.token,
          number: orderNumber,
          type: "wechat"
        })
        .then(res => {
          // 更严格的响应检查，兼容不同环境的响应结构
          if (res && res.data && res.data.code == 200 && res.data.data) {
            const payData = res.data.data;
            
            // 更新订单信息，优先使用支付接口返回的title（支付接口的title更准确）
            // 合并订单信息，确保所有字段都更新，并保证 Vue 响应式
            this.buys = Object.assign({}, this.buys, {
              // 如果支付接口返回了 title，优先使用（即使为空字符串也使用）
              title: payData.hasOwnProperty('title') ? payData.title : this.buys.title,
              number: payData.number || this.buys.number
            });
            
            // 检查是否有payCode
            if (payData.payCode) {
              this.wxPayCode = payData.payCode;
              this.showtime = false; // 隐藏加载，显示二维码
              // 启动支付状态轮询
              this.timing = setInterval(() => {
                this.pay_status();
              }, 2000);
            } else {
              console.error('支付接口返回数据中缺少payCode:', payData);
              this.$message.error('获取支付二维码失败：响应数据异常');
              this.showtime = false;
            }
          } else {
            const errorMsg = (res && res.data && res.data.message) || '获取支付二维码失败';
            console.error('支付接口响应异常:', res);
            this.$message.error(errorMsg);
            this.showtime = false;
          }
        })
        .catch(err => {
          console.error('支付请求失败:', err);
          let errorMsg = '获取支付二维码失败，请重试';
          if (err.response && err.response.data && err.response.data.message) {
            errorMsg = err.response.data.message;
          } else if (err.message) {
            errorMsg = err.message;
          }
          this.$message.error(errorMsg);
          this.showtime = false;
        });
    },
    pay_status() {
      // 查询订单状态
      this.axios
        .orderquery({
          params: {
            number: this.buys.number,
            token: this.$store.state.token
          }
        })
        .then(res => {
          if (res.data.code == 200 && res.data.data) {
            const state = res.data.data.state;
            if (state == 1 || state == 7) {
              // 支付完成或金额不符，清除本地订单号
              const fileCode = this.localOrderFileCode || this.isFrom.code;
              this.clearLocalOrderNumber(fileCode);
              this.localOrderNumber = "";
              this.localOrderFileCode = "";
              // 清除定时器
              if (this.timing) {
                clearInterval(this.timing);
                this.timing = null;
              }
              this.pay_num = 2;
              this.time = 6;
              this.timer();
            }
          }
        })
        .catch(err => {
          console.error('查询支付状态失败:', err);
        });
    },
    timer() {
      if (this.time > 0) {
        this.time--;
        setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.dialogVisible = false;
        // 清除定时器
        if (this.timing) {
          clearInterval(this.timing);
          this.timing = null;
        }
        location.reload();
      }
    },
    jump(val, item) {
      if (val == 1) {
        let link = this.$router.resolve({
          name: "details",
          query: { type: 1, code: item.code }
        });
        window.open(link.href, "_blank");
      } else if (val == 2) {
        let link = this.$router.resolve({
          name: "details",
          query: { type: 2, code: item.code }
        });
        window.open(link.href, "_blank");
      }
    },
    // 立即跳转
    jumps() {
      this.dialogVisible = false;
      location.reload();
    },
    //立即下载
    download() {
      this.axios
        .dl({
          token: this.$store.state.token,
          code: this.isFrom.code
        })
        .then(res => {
          if (res.data.code == 200) {
            var SmallFs = window.__wxjs_environment === "miniprogram";
            if (SmallFs == true) {
              wx.miniProgram.navigateTo({
                url: "/pages/util/download?fileUrl=" + this.isFrom.url
              });
            } else {
              window.location.href = this.isFrom.url;
            }
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch(err => {
          // 下载失败，静默处理
        });
    },
    handleClose(done) {
      // 对话框关闭回调
    },
    handleScroll() {
      let scrollTop =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      this.Fixed =
        scrollTop > this.floorOne + this.offsetHeight &&
        scrollTop < this.floorTwo + this.reHeight;
      this.Fixeds = scrollTop > this.floorTwo + this.reHeight;
      if (this.Fixeds == true) {
        let obj = document.getElementById("torecommed");
        obj.style.top = 20 + "px";
      }
    },
    getFloorDis() {
      setTimeout(() => {
        let floorOne = document.getElementById("torecommed").offsetTop;
        this.floorOne = floorOne;
        let floorTwo = document.getElementById("recommend").offsetTop;
        this.floorTwo = floorTwo;
      }, 300);
    },
    //收藏
    collection() {
      if (
        this.$store.state.token == "" ||
        this.$store.state.token == undefined
      ) {
        this.title = true;
      } else {
        this.axios
          .collectionlike({
            token: this.$store.state.token,
            code: this.isFrom.code,
            state: this.isFrom.collect == false ? "t" : "f"
          })
          .then(res => {
            if (res.data.code == 200) {
              this.getapp();
            }
          })
          .catch(err => {
            // 收藏操作失败，静默处理
          });
      }
    },
    // subxit(){

    // },
    // 关闭弹窗
    closei() {
      this.dialogVisible = false;
      this.dialogSmallP = false;
      // 清除支付状态轮询定时器
      if (this.timing) {
        clearInterval(this.timing);
        this.timing = null;
      }
    },
    parentFn(payload) {
      this.title = payload;
      // 登录成功后刷新页面同步登录状态
      if (payload === false) {
        // 重新检查电子卡权限
        this.checkEcardPermission();
        // 重新获取页面数据
        this.getapp();
      }
    },
    paybuy() {
      this.axios
        .orderpay({
          token: this.$store.state.token,
          number: this.buys.number,
          type: "ali"
        })
        .then(res => {
          if (res.data.code == 200) {
            let routerData = this.$router.resolve({
              path: "/orderAlipay",
              query: { htmlData: res.data.message }
            });
            // 打开新页面
            const newWin = window.open(routerData.href);
            // 发送token给新窗口
            const token = this.$store.state.token;
            // 轮询等待新窗口加载完成
            const sendToken = () => {
              if (newWin) {
                newWin.postMessage({ token }, window.location.origin);
              }
            };
            // 多次尝试发送，兼容新窗口未及时加载
            let count = 0;
            const timer = setInterval(() => {
              sendToken();
              count++;
              if (count > 10) clearInterval(timer);
            }, 300);
          }
        })
        .catch(err => {});
    }
  },
  async mounted() {
    this.loginKto();
    var query = this.$route.query;
    if (
      query.out_trade_no == undefined ||
      query.out_trade_no == "undefined" ||
      query.out_trade_no == "" ||
      query.out_trade_no == null
    ) {
      this.getapp();
    } else {
      this.axios
        .orderreturn({
          token: this.$store.state.token,
          number: query.out_trade_no
        })
        .then(res => {
          if (res.data.code == 200) {
            this.$router.push({
              name: "Detailspage",
              query: { type: res.data.data.type, code: res.data.data.code }
            });
          } else {
            return false;
          }
        })
        .catch(err => {});
    }
    
    // 检查电子卡权限
    await this.checkEcardPermission();
    
    this.getFloorDis();
    this.$nextTick(function() {
      setTimeout(() => {
        let head = document.getElementById("torecommed");
        this.offsetHeight = head.offsetHeight;
        let heads = document.getElementById("recommend");
        this.reHeight = heads.offsetHeight;
        window.addEventListener("scroll", this.handleScroll);
      }, 500);
    });
  },
  beforeDestroy() {
    // 组件销毁前清理资源
    // 清除支付状态轮询定时器
    if (this.timing) {
      clearInterval(this.timing);
      this.timing = null;
    }
    // 移除滚动事件监听
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>
<style scoped>
@import "../../styles/Page/Detailspage.css";
</style>
<style>
.preview_bread .el-breadcrumb {
  line-height: 51px;
}
.preview_bread .el-breadcrumb__inner a:hover,
.el-breadcrumb__inner.is-link:hover {
  color: #666;
}
.preview_bread .el-breadcrumb__inner.is-link {
  color: #666;
}
.pay_Popup .el-dialog {
  height: 500px;
}
.pay_Popup .el-dialog__header {
  padding: 0 50px 0 20px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  color: #3e3e3f;
  position: relative;
  margin: 0;
}
.pay_Popup .el-dialog__title {
  font-size: 14px;
  color: #3e3e3f;
  line-height: 40px;
  height: 40px;
  padding: 0;
  margin: 0;
}
.pay_Popup .el-dialog__body {
  padding: 0;
}
.SmalP_popup .el-dialog__header {
  padding: 0 0 0 0px;
  height: 40px;
  line-height: 40px;
  font-size: 12px;
  color: #3e3e3f;
  border-bottom: 1px solid #eaecee;
}
.SmalP_popup .el-dialog__title {
  font-size: 14px;
  color: #3e3e3f;
}
.SmalP_popup .el-dialog--center .el-dialog__body {
  padding: 25px 25px 15px;
}
</style>
